import Vue from 'vue';
import store from './../../store';
import OrderPickupTransformer from './../../transformers/orderPickup';

const success = ({ data }, resolve) => {
  const orderPickups = OrderPickupTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllOrderPickups', orderPickups);
  resolve(orderPickups);
};

const failed = () => {
};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/orderPickups')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/orderPickup/all.js